import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, InputAdornment } from '@mui/material';


export function TinyMceMediaSelector(params: {
    open: boolean;
    onClose: () => void;
    onImageSelect: (imageSrc: string | ArrayBuffer | null, width?: string, height?: string) => void; }) {
    const [selectedImage, setSelectedImage] = useState<string | ArrayBuffer | null>(null);
    const [width, setWidth] = useState<string>('');
    const [height, setHeight] = useState<string>('');

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                setSelectedImage(e.target?.result); // Store the selected image data URL
            };
            reader.readAsDataURL(file);
        }
    };

    function handleInsertImage() {
        const numericWidth = parseInt(width, 10);
        const numericHeight = parseInt(height, 10);

        if (selectedImage) {
            params.onImageSelect(
                selectedImage,
                isNaN(numericWidth) ? undefined : numericWidth.toString(),
                isNaN(numericHeight) ? undefined : numericHeight.toString()
            );
        }

        setSelectedImage(null);
        setWidth('');
        setHeight('');
        params.onClose();
    };

    return (
        <Dialog open={params.open} onClose={params.onClose}>
            <DialogTitle>Select an Image</DialogTitle>
            <DialogContent>
                <input type="file" accept="image/*" onChange={handleFileChange} />
                {selectedImage && (
                    <div style={{ marginTop: 20 }}>
                        <img src={selectedImage as string} alt="Preview" style={{ maxWidth: '100%', maxHeight: 200 }} />
                        <p>Preview of the selected image</p>
                        <TextField
                            label="Width"
                            variant="outlined"
                            size="small"
                            value={width}
                            onChange={(e) => setWidth(e.target.value)}
                            style={{ marginRight: '10px' }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">px</InputAdornment>,
                            }}
                        />
                        <TextField
                            label="Height"
                            variant="outlined"
                            size="small"
                            value={height}
                            onChange={(e) => setHeight(e.target.value)}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">px</InputAdornment>,
                            }}
                        />
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={params.onClose}>Cancel</Button>
                <Button onClick={handleInsertImage} disabled={!selectedImage}>Insert Image</Button>
            </DialogActions>
        </Dialog>
    );
};



